import { Checkbox, List, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useRefinementList } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';
import FilterDisplay, { FilterDisplayMode } from '../../../search/filters/FilterDisplay';
import { CompanyCategoryEnum, CompanyCategoryIconMap } from '../../../social-proof/state';
import useNormalizedCurrentRefinements from '../../../hooks/useNormalizedCurrentRefinements';

export interface CompanyCategoryFilterProps {
  mode: FilterDisplayMode;
}

export const CompanyCategoryOptions = [
  {
    category: CompanyCategoryEnum.WHOLESALER,
    refinementValue: 'true',
  },
  {
    category: CompanyCategoryEnum.NON_LOCAL_PRODUCER,
    refinementValue: 'false',
  },
];

export default function CompanyCategoryFilter({ mode }: CompanyCategoryFilterProps): React.JSX.Element {
  const { t } = useTranslation(['discovery', 'social-proof']);
  const { items, refine } = useRefinementList({ attribute: 'is_wholesaler' });
  const currentRefinements = useNormalizedCurrentRefinements('is_wholesaler');

  return (
    <FilterDisplay
      label={t('discovery:supplier_type')}
      name="social_tags_lvl3"
      activeItemCount={items.filter(({ isRefined }) => isRefined).length}
      content={(
        <List>
          {CompanyCategoryOptions.map(({ category, refinementValue }) => (
            <ListItemButton
              onClick={() => refine(refinementValue)}
              key={category}
            >
              <ListItemAvatar sx={{ minWidth: 40, height: 40 }}>
                <img src={CompanyCategoryIconMap[category]} loading="lazy" alt="" height="40" width="40" />
              </ListItemAvatar>
              <ListItemText primary={t(`social-proof:${category.toLowerCase()}.title`)} />
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={currentRefinements.includes(refinementValue)}
                />
              </ListItemIcon>
            </ListItemButton>
          ))}
        </List>
      )}
      mode={mode}
    />
  );
}
